import React from 'react';
import {Table} from '../../../components/table/Table';
import {UserAvatarWithNameAndEmail} from '../../reimbursement/components/ReimbursementColumnRenders';
import { Text } from '@unthinkable/react-core-components';
import { PrimaryColumnCard } from '../../../components/card/PrimaryColumnCard';

const EmployeeListWithDetailAllocation = props => {
  let {
    params = {},
    filterValues: {filter = {}, params: filterParams = {}} = {},
  } = props || {};
  return (
    <Table
      params={{...params, ...filterParams}}
      addOnFilter={{...filter}}
      api={`/resourceallocation`}
      variant={'bordered'}
      columns={[
        {
          header: 'Employee',
          field: 'employee',
          render: ({row}) => {
            const {employee} = row;
            return (
              <UserAvatarWithNameAndEmail
                name={employee?.name}
                color={employee?.color}
                values={[
                  {value: employee?.official_email_id},
                  {value: `${employee?.experience} yrs`},
                ]}
              />
            );
          },
          minWidth: 300,
        },
        {
          header: 'Front Facing',
          render: ({row}) => {
            const {front_facing_resource} = row;
            if (!front_facing_resource?._id) return null;
            return (
              <UserAvatarWithNameAndEmail
                name={front_facing_resource?.name}
                color={front_facing_resource?.color}
                values={[
                  {value: front_facing_resource?.official_email_id},
                  {value: `${front_facing_resource?.experience} yrs`},
                ]}
              />
            );
          },
          minWidth: 300,
        },
        {
          header: 'Project',
          field: 'project_id.project',
          width: 150,
        },
        {
          header: 'Project Type',
          render: ({row, styles: {rowText = {}} = {}}) => {
            const {project_id} = row;
            let projectType = '-';
            if (project_id?.projecttype == 'tm') {
              projectType = 'T&M';
            } else if (project_id?.projecttype == 'f') {
              projectType = 'Fixed';
            } else if (project_id?.projecttype == 'i') {
              projectType = 'Internal';
            }
            return <Text style={{...rowText}}>{projectType}</Text>;
          },
          width: 120,
        },
        {
          header: 'Customer',
          field: 'order.customer_id.name',
          width: 150,
        },
        {
          header: 'Order',
          field: 'order.order_number',
          width: 100,
        },
        {
          header: 'Number',
          type: 'text',
          render: ({row, styles}) => {
            return (
              <Text style={{...styles.rowText}}>
                {row?.milestone_id?.order_milestone_no ||
                  row?.skill_requirement?.skill_requirement_no ||
                  ''}
              </Text>
            );
          },
        },
        {
          header: 'Hours',
          field: 'hours',
          type: 'number',
          width: 80,
        },
        {
          header: 'From Date',
          field: 'from_date',
          type: 'date',
          formatOptions: {
            format: 'DD MMM YYYY',
          },
          width: 120,
        },
        {
          header: 'To Date',
          field: 'to_date',
          type: 'date',
          formatOptions: {
            format: 'DD MMM YYYY',
          },
          width: 120,
        },
        {
          header: 'Practice',
          field: 'practice.name',
          width: 150,
        },
        {
          header: 'Resource Skill',
          field: 'resource_skill.name',
          width: 150,
        },
        {
          header: 'Resource Tool',
          field: 'resource_tool.name',
          width: 150,
        },
        {
          header: 'Project Skill',
          field: 'project_skill.name',
          width: 150,
        },
        {
          header: 'Project Tool',
          field: 'tool.name',
          width: 150,
        },
        {
          header: 'Account Manager',
          field: 'account_manager.name',
          width: 150,
        },
        {
          header: 'Type',
          field: 'assigned_type',
          width: 150,
        },
        {
          header: 'Level 1 Owner',
          field: 'level_one_owner.name',
          width: 150,
        },
        {
          header: 'Level 2 Owner',
          field: 'level_two_owner.name',
          width: 150,
        },
        {
          header: 'Level 3 Owner',
          field: 'level_three_owner.name',
          width: 150,
        },
        {
          header: 'Incentive Mode',
          render: ({row}) => {
            return (
              <PrimaryColumnCard
                primaryTitle={
                  row?.incentive_mode || ""
                }
                items={[{value: row?.incentive_shared_with?.name}]}
              />
            );
          },
          width: 150,
        },
        {
          header: 'Self/Front Facing Not Allow',
          render: ({row, styles: {rowText = {}}}) => {
            return (
              <Text style={{...rowText}}>{row?.self_front_facing_not_allow ? 'Yes' : ' '}</Text>
            );
          },
          width: 170,
        },
      ]}
    />
  );
};

export default EmployeeListWithDetailAllocation;
